module.exports = __webpack_public_path__ + "static/icon_gambit-c164716bba4b7b0b1285e92129b6be36.svg";